<template>
  <section id="section__fee" class="px-3">
    <v-row no-gutters class="landing-container">
      <v-col cols="12" class="mb-5">
        <p class="font--p-5 font-weight-black mb-2">이용 수수료</p>
        <p class="font--m-6">
          이용 수수료는 일 선정산 금액의
          <span style="color: #ff5656">0.027%</span> 로 <br />
          가장 저렴하게 제공해 드리고 있어요
        </p>
      </v-col>

      <v-col cols="12" class="mb-10">
        <p class="font--p-2 text-center">
          일 {{ parseInt(amounts[value] * 0.0002685) | commaFormat }} 원
        </p>
      </v-col>

      <v-col class="pr-4 mt-2">
        <v-slider
          v-model="value"
          color="gray"
          track-color="gray"
          class="align-center"
          min="0"
          max="5"
          thumb-color="black"
          :thumb-size="50"
          thumb-label="always"
        >
          <template v-slot:thumb-label="{ value }">
            <div class="text-center">
              일매출 <br />{{ (amounts[value] / 10000) | commaFormat }}만
            </div>
          </template>
        </v-slider>
      </v-col>

      <v-col v-if="showApply" cols="12" class="mt-10 text-center px-8">
        <v-btn block class="apply-btn" :to="{ name: 'signup/agreements/nice' }">
          번개입금 신청하기
        </v-btn>
      </v-col>
    </v-row>
  </section>
</template>

<script>
export default {
  props: {
    showApply: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      amounts: [0, 300000, 500000, 1000000, 1500000, 2000000],
      value: 2,
    }
  },
}
</script>

<style lang="scss" scoped>
#section__fee {
  display: flex !important;
  flex-direction: column;
  overflow: hidden;
  background-color: #eef6fa;

  .apply-btn {
    background-color: #d30000;
    color: white;
    height: 50px;
    font-size: 20px;
  }
}
</style>
